import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// 👇 IMPORTAMOS EL STORE
import { useAuthStore } from "./store/auth.store";

// 👇 INICIALIZAMOS AUTH ANTES DE RENDERIZAR REACT
useAuthStore.getState().init();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
